import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GenerateAttendanceSessionPDFRequest {
  sessionId: string;
  showBalance: boolean;
}

export interface GenerateAttendanceSessionPDFResponse {
  success: boolean;
  jobId: string;
  message: string;
}

export const generateAttendanceSessionPDFAPI = async (
  params: GenerateAttendanceSessionPDFRequest,
) => {
  const response = await baseAPI.post<GenerateAttendanceSessionPDFResponse>(
    `/attendance/generate-session-pdf`,
    params,
  );
  return response.data;
};

// Note: queryOptions is not needed for mutations, only for queries

export const useGenerateAttendanceSessionPDF = () => {
  return useMutation({
    mutationFn: generateAttendanceSessionPDFAPI,
    mutationKey: [KEYS.ATTENDANCE_SESSION_PDF_JOBS, 'generate'],
  });
};
